const CURRENT_USER_KEY = 'currentUser'
const LAST_LOGIN_USERNAME_KEY = 'adnuntius.last-login-username'
const MASQUERADE_KEY = 'adn-masquerade'
const MASQUERADE_ENABLED_KEY = 'adn-masquerade-enabled'

export interface SessionUser {
  id: string
  username: string
  displayName: string
}

export interface MasqueradeState {
  targetUsername: string
  originalToken: string
  /** The support user who signed in to masquerade; absent for passkey sign-ins without a typed username. */
  supportUsername?: string
}

export const StorageService = {
  getCurrentUser: (): SessionUser | null => {
    const data = localStorage.getItem(CURRENT_USER_KEY)
    return data ? JSON.parse(data) : null
  },

  setCurrentUser: (user: SessionUser | null) => {
    if (user) {
      localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(user))
    } else {
      localStorage.removeItem(CURRENT_USER_KEY)
    }
  },

  getLastLoginUsername: (): string => {
    return localStorage.getItem(LAST_LOGIN_USERNAME_KEY) ?? ''
  },

  setLastLoginUsername: (username: string) => {
    if (username) localStorage.setItem(LAST_LOGIN_USERNAME_KEY, username)
  },

  getMasquerade: (): MasqueradeState | null => {
    const data = localStorage.getItem(MASQUERADE_KEY)
    return data ? JSON.parse(data) : null
  },

  setMasquerade: (state: MasqueradeState | null) => {
    if (state) {
      localStorage.setItem(MASQUERADE_KEY, JSON.stringify(state))
    } else {
      localStorage.removeItem(MASQUERADE_KEY)
    }
  },

  isMasqueradeEnabled: (): boolean => {
    return localStorage.getItem(MASQUERADE_ENABLED_KEY) === 'true'
  },

  enableMasquerade: () => {
    localStorage.setItem(MASQUERADE_ENABLED_KEY, 'true')
  },
}
